const BASE58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"

// Wallets hand back the signature as raw bytes; the server records it in the
// same base58 form a block explorer shows.
export function toBase58(bytes) {
  const digits = [0]
  for (const byte of bytes) {
    let carry = byte
    for (let i = 0; i < digits.length; i++) {
      carry += digits[i] << 8
      digits[i] = carry % 58
      carry = (carry / 58) | 0
    }
    while (carry > 0) {
      digits.push(carry % 58)
      carry = (carry / 58) | 0
    }
  }
  let out = ""
  for (const byte of bytes) {
    if (byte !== 0) break
    out += BASE58[0]
  }
  for (let i = digits.length - 1; i >= 0; i--) out += BASE58[digits[i]]
  return out
}
